import type { RegionOption } from '../../../../shared/regionAccessOptions';
import RegionAccessPicker from '../../../../shared/RegionAccessPicker';
import { DIRECTOR_REGION_HINT, includesDirectorRole } from '../director-regions';
import type { UserRoleId } from '../roleTaxonomy';

import EditRoleSection from './EditRoleSection';
import RoleCheckboxGroup from './RoleCheckboxGroup';

interface BodyProps {
  regions: RegionOption[];
  selectedRoleIds: UserRoleId[];
  selectedRegionIds: string[];
  lockedRegionIds: string[];
  /** Roles the viewer may grant. Empty hides the roles section. */
  grantableRoleIds: UserRoleId[];
  /** Whether the viewer may change this user's regions. */
  canEditRegions: boolean;
  onRolesChange: (ids: UserRoleId[]) => void;
  onRegionsChange: (ids: string[]) => void;
}

export default function EditRoleBody({
  regions,
  selectedRoleIds,
  selectedRegionIds,
  lockedRegionIds,
  grantableRoleIds,
  canEditRegions,
  onRolesChange,
  onRegionsChange,
}: BodyProps) {
  const isDirector = includesDirectorRole(selectedRoleIds);
  return (
    <div className="px-[22px] py-[18px] overflow-auto flex flex-col gap-4">
      {grantableRoleIds.length > 0 && (
        <EditRoleSection label="Roles" hint="Multi-role — pick all that apply.">
          <RoleCheckboxGroup
            value={selectedRoleIds}
            onChange={onRolesChange}
            grantableIds={grantableRoleIds}
          />
        </EditRoleSection>
      )}

      {canEditRegions && (
        <EditRoleSection
          label={isDirector ? 'Region' : 'Regions'}
          accent={isDirector ? 'one region' : 'multi-select'}
          hint={isDirector ? DIRECTOR_REGION_HINT : undefined}
        >
          <RegionAccessPicker
            options={regions}
            selectedIds={selectedRegionIds}
            onChange={onRegionsChange}
            lockedIds={lockedRegionIds}
            single={isDirector}
          />
        </EditRoleSection>
      )}
    </div>
  );
}
